import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mcDataFilter'
})
export class DataFilterPipe implements PipeTransform {

    transform(array: Array<{}>, args: any[]): Array<{}> {

        array = array || [];
        const returnFilterCount = (args.length > 1 && args[1]);

        if (args === null || typeof args === 'undefined' || args.length === 0 ||
            args[0] === undefined || args[0].searchTerm === 'undefined'
            || args[0].searchTerm === null || args[0].searchTerm.trim() === '') {
            if (returnFilterCount) {
                args[1].Count = array.length;
            }
            return array;
        }

        const filtered = array.filter((item: any) => {
            let isMatch = false;
            for (const key of Object.keys(args[0].keys)) {
                const propName = args[0].keys[key];
                if (item.hasOwnProperty(propName) && item[propName] !== null) {
                    isMatch = item[propName].toString().toLowerCase().search(args[0].searchTerm.toLowerCase().trim()) >= 0;
                }

                if (isMatch) { break; }
            }
            return isMatch;
        });

        if (returnFilterCount) {
            args[1].Count = filtered.length;
        }
        return filtered;

    }

}
